// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@conklin/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import { css } from "styled-components";

savedOrderListTableStyles.container = {
    css: css`
        overflow: auto;
    `,
};

savedOrderListTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

savedOrderListTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

savedOrderListTableStyles.subtotalCell = {
    alignX: "left",
};

savedOrderListTableStyles.subtotalHeader = {};

savedOrderListTableStyles.dataTable = {
    css: css`
        [data-test-selector="savedOrderLine_shipTo"] [class^="ValueTypography"] {
            white-space: normal;
        }
    `,
};
